import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const EditIcon = ({ size, color, title, onClick, decorative, ...restItems }: IconProps) => (
	<IconBase
		viewBox="0 0 40 40"
		size={size}
		color={color}
		title={title}
		onClick={onClick}
		decorative={decorative}
		{...restItems}
	>
		<path
			d="M0 14.4C0 9.35953 0 6.83929 0.980941 4.91409C1.8438 3.22063 3.22063 1.8438 4.91409 0.980941C6.83929 0 9.35953 0 14.4 0H25.6C30.6405 0 33.1607 0 35.0859 0.980941C36.7794 1.8438 38.1562 3.22063 39.0191 4.91409C40 6.83929 40 9.35953 40 14.4V25.6C40 30.6405 40 33.1607 39.0191 35.0859C38.1562 36.7794 36.7794 38.1562 35.0859 39.0191C33.1607 40 30.6405 40 25.6 40H14.4C9.35953 40 6.83929 40 4.91409 39.0191C3.22063 38.1562 1.8438 36.7794 0.980941 35.0859C0 33.1607 0 30.6405 0 25.6V14.4Z"
			fill="#7A7977"
			fillOpacity="0.08"
		/>
		<path
			d="M13.9844 22.6211C14.0938 22.2383 14.3125 21.8828 14.5859 21.6094L22.8984 13.2969C23.582 12.6133 24.7031 12.6133 25.3867 13.2969L26.4531 14.3633C26.5352 14.4453 26.6172 14.5547 26.6719 14.6367C27.1367 15.3203 27.0547 16.25 26.4531 16.8516L18.1406 25.1641C18.1133 25.1914 18.0586 25.2188 18.0312 25.2734C17.7578 25.4922 17.457 25.6562 17.1289 25.7656L14.9961 26.3945L13.8203 26.75C13.6016 26.8047 13.3555 26.75 13.1914 26.5586C13 26.3945 12.9453 26.1484 13.0273 25.9297L13.3555 24.7539L13.9844 22.6211ZM15.2422 23.0039L15.0508 23.6328L14.6133 25.1367L16.1172 24.6992L16.7461 24.5078C16.9375 24.4531 17.0742 24.3711 17.2109 24.2344L23.4727 17.9727L21.7773 16.2773L15.5156 22.5391C15.4883 22.5391 15.4883 22.5664 15.4609 22.5938C15.3516 22.7031 15.2969 22.8398 15.2422 23.0039Z"
			fill="#62615F"
		/>
	</IconBase>
);
